import { render, staticRenderFns } from "./Announce.vue?vue&type=template&id=28f3f1c6"
import script from "./Announce.vue?vue&type=script&lang=js"
export * from "./Announce.vue?vue&type=script&lang=js"
import style0 from "./Announce.vue?vue&type=style&index=0&id=28f3f1c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports